import { render } from "./Field.vue?vue&type=template&id=2588fca4"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__